import { get, post, postJson, patch, getCookie } from '../../../utils/request'
import {
  LOGIN_URL,
  LOGOUT_URL,
  USER_ROLES_URL,
  USER_UPDATE_URL,
  AUTHENTICATE_FACEBOOK_URL,
  USER_INFO,
  REGISTRATION_URL,
  SEND_CODE_URL,
  COMPARE_CODE_URL,
  SEND_RESET_PASSWORD,
  SEND_CONFIRM_RESET_PASSWORD,
  AUTHENTICATE_GOOGLE_URL,
  SEND_CONTACT_US,
  CHECK_EMAIL_OR_PHONE_EXISTS,
  CHAT_TOKEN,
  MSG_SAVE
} from '../../../utils/urls'
import { TOKEN_NAME } from '../../../utils/constants'

const actions = {
  login: async (context, payload) => {
    let response = await postJson(LOGIN_URL, payload.params)
    let token = response.data.key
    if (token) {
      context.commit('updateToken', token)
    }
    return response
  },
  authenticateGoogle: async (context, payload) => {
    let response = await post(AUTHENTICATE_GOOGLE_URL, {
      access_token: payload.accessKey
    })
    let token = response.data.key
    if (token) {
      context.commit('updateToken', token)
    }
    return response
  },
  authenticateFacebook: async (context, payload) => {
    let response = await post(AUTHENTICATE_FACEBOOK_URL, {
      access_token: payload.accessKey
    })
    let token = response.data.key
    if (token) {
      context.commit('updateToken', token)
    }
    return response
  },
  logout: async (context) => {
    await post(LOGOUT_URL, null)
    context.commit('clearUserInfo')
  },
  registerUser: async (context, payload) => {
    let response = await post(REGISTRATION_URL, payload.params)
    let token = response.data.key
    if (token) {
      context.commit('updateToken', token)
    }
    return response
  },
  getUserRoles: async (context) => {
    let response = await get(USER_ROLES_URL)
    context.commit('setUserRoles', response.data.results)
  },
  updateUser: async (context, payload) => {
    return patch(USER_UPDATE_URL, payload.params)
  },
  checkAuth: async (context) => {
    try {
      let token = getCookie(TOKEN_NAME)
      if (token) {
        let response = await get(USER_INFO)
        let status = response.status
        if (status === 200) {
          context.commit('updateAuthenticate', true)
          context.commit('updateUserInfo', response.data)
          // context.commit('updateToken', null)
        } else {
          context.commit('updateAuthenticate', false)
          context.commit('clearUserInfo')
        }
      }
    } catch (e) {
      context.commit('updateAuthenticate', false)
      context.commit('clearUserInfo')
    }
  },
  sendConfirmCode: async (context, payload) => {
    await post(SEND_CODE_URL, payload.params)
  },
  compareConfirmCode: async (context, payload) => {
    await post(COMPARE_CODE_URL, payload.params)
  },
  sendResetPassword: async (context, payload) => {
    await post(SEND_RESET_PASSWORD, payload.params)
  },
  sendConfirmCodePassword: async (context, payload) => {
    await post(SEND_CONFIRM_RESET_PASSWORD, payload.params)
  },
  sendContactUs: (context, payload) => {
    return post(SEND_CONTACT_US, payload.body)
  },
  checkEmailOrPhoneExists: async (context, payload) => {
    return get(CHECK_EMAIL_OR_PHONE_EXISTS, payload.query)
  },
  getChatToken: async (context, payload) => {
    return post(CHAT_TOKEN, {
      user_id: payload.id
    })
  },
  saveMessage: async (context, payload) => {
    return post(MSG_SAVE, {
      sender: payload.sender,
      conversation: payload.conversation,
      message_sid: payload.message_sid,
      body: payload.body,
      created_at: payload.created_at,
      participant_sid: payload.participant_sid
    })
  }
}

export default actions
